/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
    },
    registered (registration) {
      // check ogni ora degli aggiornamenti
      setInterval(() => {
        registration.update();
      }, 1000 * 60 * 60);
    },
    cached () {

    },
    updatefound (registration) {
    },
    updated (registration) {
      document.dispatchEvent(
          new CustomEvent('updateAvailable', { detail: registration })
      );
    },
    offline () {
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
